import { render, staticRenderFns } from "./ucgossip.vue?vue&type=template&id=3a435868&scoped=true"
import script from "./ucgossip.vue?vue&type=script&lang=js"
export * from "./ucgossip.vue?vue&type=script&lang=js"
import style0 from "./ucgossip.vue?vue&type=style&index=0&id=3a435868&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a435868",
  null
  
)

export default component.exports